module.exports = __webpack_public_path__ + "static/img/anker.61cb09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/anker.png
// module id = u//p
// module chunks = 9